:host {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers vertically when narrow */
    align-items: center;     /* Centers horizontally when wide */
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 256px;
    min-height: 240px;
    container-type: size;
}

main {
    position: relative;
    box-sizing: border-box;
    aspect-ratio: 256 / 240;

    width: 100%;
    height: auto;

    max-height: 100%;
    max-width: calc(100cqh * (256 / 240));

    min-width: 256px;
    min-height: 240px;

    & > canvas {
        background: #000;
        width: 100%;
        height: 100%;
        display: block;
    }

    & > section {
        @include flex-row(flex-start, center);
        gap: 8px;
        position: absolute;
        top: 8px;
        right: 8px;
        padding: 8px;
        border-radius: 5px;
        backdrop-filter: blur(8px) grayscale(0.5);
        background-color: rgba(0, 0, 0, .5);
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    &:hover > section {
        opacity: 1;
    }
}
